import { render } from "./IntegrationConnectionsLoader.vue?vue&type=template&id=27db7970&ts=true"
import script from "./IntegrationConnectionsLoader.vue?vue&type=script&lang=ts"
export * from "./IntegrationConnectionsLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__